import React, { useEffect, useRef } from 'react'
import config from '@yuanfudao/metis-unified-login/es/config'
import { getWxRedirectUrl } from '@yuanfudao/metis-unified-login'
import fakeQrCode from '@/assets/login-new/fake-qr-code.png'
import { useGlobalState } from '@/store'
import lessModule from './index.module.less'
import { useLocation } from 'react-router-dom'

interface QrCodeContentProps{
  isCheckAgreement: boolean,
  afterLoginSuccess:()=>void,
}

const targetUrlReg = /#\/login(?!\/bind)/g
const replacement = '#/login/bind'

export const QrCodeContent = ({ isCheckAgreement, afterLoginSuccess }: QrCodeContentProps) => {
  const { setIsLogin } = useGlobalState()
  const wxScanStateRef = useRef('')
  const timer = useRef(0)
  const location = useLocation()

  useEffect(() => {
    // 很重要，不能删，切换老师版和学生版的时候，会改变URL，需要重新初始化微信扫码
    const p = location
    console.log('location', p)
    let publicPath = window.location.origin + window.location.pathname
    if (publicPath.endsWith('index.html')) {
      publicPath = publicPath.slice(0, publicPath.lastIndexOf('index.html'))
    }
    const state = String(Math.random())
    wxScanStateRef.current = state

    const targetUrl = getWxRedirectUrl().replace(targetUrlReg, replacement)
    const redirectUrlWx = `${config.WX_SCAN_REDIRECT_location}/metis-weixin/api/ws/${config.WX_SCAN_APPID}/oauth-forward?redirectUrl=${encodeURIComponent(targetUrl)}`

    // @ts-ignore
    // eslint-disable-next-line
    const obj = new WxLogin({
      self_redirect: false,
      id: 'login_container',
      appid: config.WX_SCAN_APPID,
      scope: 'snsapi_login',
      redirect_uri: encodeURIComponent(redirectUrlWx),
      state,
      style: '',
      href: encodeURIComponent(`${publicPath}wx-scan.css`),
    })
    // location 的依赖很重要，不能删，切换老师版和学生版的时候，会改变URL，需要重新初始化微信扫码
  }, [afterLoginSuccess, location, setIsLogin])

  useEffect(() => () => {
    clearTimer()
  })

  const clearTimer = () => {
    clearInterval(timer.current)
    timer.current = 0
  }

  return (
    <div className={lessModule.qrCodeWrap}>
      <div id="login_container" style={{ opacity: isCheckAgreement ? 1 : 0 }} />
      {
        !isCheckAgreement && (
          <>
            <div className={lessModule.fakeQrCodeWrap}>
              <img className={lessModule.fakeQrCode} src={fakeQrCode} alt="" />
            </div>
            <div className={`${lessModule.qrCodeMask} fontBold`}>请先阅读并勾选底部的协议</div>
          </>
        )
      }

    </div>
  )
}
